import { hasBetaAccess, hasSameindAccess, useAuth } from '@/contexts/AuthContext';
import type { BloodTestOrderingGate } from './bloodTests.types';

/**
 * Blood-test ordering needs the features:sameind or features:beta flag and a Sameind org. Everyone sees blóðprufur
 * tasks; outside the gate they are plain text requests. Ordering additionally needs a læknanúmer.
 * Impersonating admins can't order: it would go out under the doctor's læknanúmer.
 */
export const useBloodTestOrderingGate = (): BloodTestOrderingGate => {
  const { user } = useAuth();
  const provider = user?.orgSettings?.defaultLabProvider ?? 'sameind';
  const orderingEnabled =
    (hasSameindAccess(user) || hasBetaAccess(user)) && provider === 'sameind' && user?.hasSameindStofnun === true;
  return { orderingEnabled, canOrder: orderingEnabled && user?.hasLaeknanumer === true && !user?.impersonating };
};
